// extracted by mini-css-extract-plugin
export default {"newDot":"rHznyWbYOcUBQNpYaZqB"};